import { render, staticRenderFns } from "./ApprovalBaseSheetUpload.vue?vue&type=template&id=6faaa9f6&"
import script from "./ApprovalBaseSheetUpload.vue?vue&type=script&lang=ts&"
export * from "./ApprovalBaseSheetUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports